import { render, staticRenderFns } from "./FlexColumnModV2.vue?vue&type=template&id=711cbee8"
import script from "./FlexColumnModV2.vue?vue&type=script&lang=js"
export * from "./FlexColumnModV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports